import apiAuth from "@/services/http/apiAuth";
import api from "@/services/http/api";

export async function importarDatos(category, file) {
  const formData = new FormData();
  formData.append("file", file);

  const res = await apiAuth.post(`/imports/${category}`, formData);
  return res.data;
}

const exportEndpoints = {
  news: "/news/admin/all",
  stories: "/news/admin/all",
  appointments: "/appointments/admin/all",
  tournaments: "/tournaments/admin/all",
  associations: "/asociaciones/admin/all",
  clubs: "/clubes/admin/all",
  "young-players": "/young-players/admin/all",
  referents: "/referentes/admin/all",
  "site-media": "/site-media",
  "site-settings": "/site-settings",
  federation: "/site-settings",
  categories: "/tournaments/categories/catalog",
};

export async function exportarDatos(category) {
  if (category === "provinces") {
    const res = await api.get("/site-settings");
    const setting = (res.data?.items || []).find((item) => item.key === "instituciones.provincias");
    return { items: JSON.parse(setting?.value || "[]") };
  }
  if (category === "contacts") {
    const res = await apiAuth.get("/appointments/admin/contacts");
    return res.data;
  }
  if (category === "accommodation") {
    const [settingsRes, mediaRes] = await Promise.all([
      api.get("/site-settings"),
      api.get("/site-media"),
    ]);
    const settings = settingsRes.data?.items || settingsRes.data || [];
    const media = mediaRes.data?.items || mediaRes.data || [];
    return {
      items: [
        ...settings
          .filter((item) => item.key === "alojamiento.content")
          .map((item) => ({ ...item, resourceType: "site-setting" })),
        ...media
          .filter((item) => item.key === "alojamiento.hero")
          .map((item) => ({ ...item, resourceType: "site-media" })),
      ],
    };
  }

  const endpoint = exportEndpoints[category];
  if (!endpoint) throw new Error("Categoría no soportada.");

  const client = ["site-media", "site-settings", "federation"].includes(category)
    ? api
    : apiAuth;
  const params = category === "tournaments" ? { limit: 1000 } : undefined;
  const res = await client.get(endpoint, { params });
  let items = res.data?.items || res.data || [];
  if (category === "tournaments") {
    const total = Number(res.data?.total);
    while (Number.isFinite(total) && items.length < total) {
      const next = await client.get(endpoint, { params: { limit: 1000, offset: items.length } });
      if (!Array.isArray(next.data?.items) || !next.data.items.length) {
        throw new Error("No se pudieron exportar todos los torneos. Intentá nuevamente.");
      }
      items = [...items, ...next.data.items];
    }
  }
  if (["tournaments", "associations", "clubs"].includes(category)) {
    const res = await api.get("/site-settings");
    const setting = (res.data?.items || []).find((item) => item.key === "instituciones.provincias");
    const provinces = JSON.parse(setting?.value || "[]");
    items = items.map((item) => ({
      ...item,
      provincia: provinces.find((province) => province.id === item.provinceId)?.name || null,
    }));
  }

  if (category === "clubs") {
    const associationsRes = await apiAuth.get("/asociaciones/admin/all");
    const associations = associationsRes.data?.items || associationsRes.data || [];
    const associationsById = new Map(
      associations.map((association) => [String(association.id), association]),
    );

    items = items.map((item) => {
      const currentAssociation = item.asociacion || item.association;
      const associationId =
        item.asociacionId ||
        item.associationId ||
        (typeof currentAssociation === "object" ? currentAssociation?.id : null);
      const association = associationsById.get(String(associationId));

      return {
        ...item,
        asociacion:
          association?.name ||
          (typeof currentAssociation === "object"
            ? currentAssociation?.name
            : currentAssociation) ||
          "",
        asociacionSlug:
          association?.slug ||
          item.asociacionSlug ||
          item.associationSlug ||
          (typeof currentAssociation === "object" ? currentAssociation?.slug : "") ||
          "",
        asociacionUuid:
          association?.uuid ||
          item.asociacionUuid ||
          (typeof currentAssociation === "object" ? currentAssociation?.uuid : "") ||
          "",
      };
    });
  }

  if (category === "news") {
    items = items.filter((item) => (item.type || "NOTICIA") === "NOTICIA");
  }
  if (category === "stories") {
    items = items.filter((item) => item.type === "HISTORIA");
  }
  if (category === "federation") {
    items = items.filter((item) =>
      String(item.key || "").startsWith("federation."),
    );
  }

  return { items };
}
